import { useState, useEffect } from "react";

// Neuro-aesthetic color system - unified accent
const COLORS = {
  oliveSage: "#a07830",
};

export default function ProgressBar() {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const updateProgress = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
      setScrollProgress(progress);
    };

    window.addEventListener("scroll", updateProgress);
    updateProgress();

    return () => window.removeEventListener("scroll", updateProgress);
  }, []);

  return (
    <div 
      className="fixed top-0 left-0 right-0 h-0.5 z-[100] bg-transparent"
      data-testid="progress-bar"
    >
      <div
        className="h-full transition-all duration-150 ease-out"
        style={{ 
          width: `${scrollProgress}%`,
          backgroundColor: COLORS.oliveSage
        }}
      />
    </div>
  );
}
